(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('mobile-localization')) {
    customElements.define(
      'mobile-localization',
      class MobileLocalization extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector('.macorner-mobile-localization__trigger');
          this.panel = this.querySelector('.macorner-mobile-localization__panel');
          if (!this.trigger || !this.panel) return;

          this.onTriggerClick = this.toggle.bind(this);
          this.onDocumentClick = this.handleDocumentClick.bind(this);
          this.onKeydown = this.handleKeydown.bind(this);

          this.trigger.addEventListener('click', this.onTriggerClick);
          document.addEventListener('click', this.onDocumentClick);
          document.addEventListener('keydown', this.onKeydown);
        }

        disconnectedCallback() {
          this.trigger?.removeEventListener('click', this.onTriggerClick);
          document.removeEventListener('click', this.onDocumentClick);
          document.removeEventListener('keydown', this.onKeydown);
        }

        toggle() {
          if (this.classList.contains('is-open')) {
            this.close();
          } else {
            this.open();
          }
        }

        open() {
          this.classList.add('is-open');
          this.panel.hidden = false;
          this.trigger.setAttribute('aria-expanded', 'true');
        }

        close(returnFocus = false) {
          this.classList.remove('is-open');
          this.panel.hidden = true;
          this.trigger.setAttribute('aria-expanded', 'false');
          if (returnFocus) this.trigger.focus();
        }

        handleDocumentClick(event) {
          if (this.classList.contains('is-open') && !this.contains(event.target)) this.close();
        }

        handleKeydown(event) {
          if (event.key === 'Escape' && this.classList.contains('is-open')) this.close(true);
        }
      }
    );
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.mobileSearchMedia = window.matchMedia('(max-width: 749px)');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.onMobileSearchMediaChange = (event) => {
        if (!event.matches) this.classList.remove('dm-mobile-search-hidden');
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.mobileSearchMedia.addEventListener('change', this.onMobileSearchMediaChange);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mobileSearchMedia.removeEventListener('change', this.onMobileSearchMediaChange);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const useMobileSearchBehavior = this.mobileSearchMedia.matches;
      const mobileSearchHasFocus =
        useMobileSearchBehavior &&
        document.activeElement &&
        document.activeElement.closest('.macorner-header-search');

      if ((this.predictiveSearch && this.predictiveSearch.isOpen) || mobileSearchHasFocus) {
        this.classList.remove('dm-mobile-search-hidden');
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (useMobileSearchBehavior) {
          this.classList.add('dm-mobile-search-hidden');
          this.header.classList.add('shopify-section-header-sticky', 'animate');
          this.header.classList.remove('shopify-section-header-hidden');
        } else {
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (useMobileSearchBehavior) {
          this.classList.remove('dm-mobile-search-hidden');
          this.header.classList.add('shopify-section-header-sticky', 'animate');
          this.header.classList.remove('shopify-section-header-hidden');
        } else {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.classList.remove('dm-mobile-search-hidden');
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
